import { render, staticRenderFns } from "./interBeneficiaryInfo.vue?vue&type=template&id=76c74432"
import script from "./interBeneficiaryInfo.vue?vue&type=script&lang=js"
export * from "./interBeneficiaryInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports